import { SITE_ICP, SITE_MPS } from '@/lib/siteBeianConfig';

type SiteBeianLinksProps = {
  className?: string;
};

export default function SiteBeianLinks({ className = 'site-beian-links' }: SiteBeianLinksProps) {
  return (
    <p className={className}>
      <a href={SITE_MPS.href} target="_blank" rel="noreferrer" className="site-beian-mps">
        <img src={SITE_MPS.iconSrc} alt="" width={16} height={16} aria-hidden />
        {SITE_MPS.label}
      </a>
      <span className="site-beian-sep" aria-hidden>
        ·
      </span>
      <a href={SITE_ICP.href} target="_blank" rel="noopener noreferrer">
        {SITE_ICP.label}
      </a>
    </p>
  );
}
